import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { ControlledProductMenu, } from "./ControlledProductMenu";
export const ProductMenu = ({ isOpenByDefault = false, ...rest }) => {
    const [isOpen, setIsOpen] = useState(isOpenByDefault);
    return (_jsx(ControlledProductMenu, { ...rest, isOpen: isOpen, setIsOpen: setIsOpen }));
};
